enum ModalToOpen {
	DuplicateCatalogDialog = "DuplicateCatalogDialog",
	DuplicateArticleDialog = "DuplicateArticleDialog",
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	Clone = "Clone",
	PullHandler = "PullHandler",

	ImportModal = "ImportModal",

	FragmentAlreadyUseWarn = "FragmentAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateStorage = "CreateStorage",

	EnterpriseLogout = "EnterpriseLogout",
	RepositoryPermission = "RepositoryPermission",

	TemplateContentWarning = "TemplateContentWarning",
	PropertySettings = "PropertySettings",

	CloudModal = "CloudModal",

	CreateWorkspaceForm = "CreateWorkspaceForm",
	EditWorkspaceForm = "EditWorkspaceForm",

	MediaPreview = "MediaPreview",
	FilePreview = "FilePreview",

	// Article dropdown modals
	ItemPropsEditor = "ItemPropsEditor",
	MarkdownEditor = "MarkdownEditor",
	BugsnagModal = "BugsnagModal",
	UnsupportedElements = "UnsupportedElements",
	Share = "Share",
	NotificationSettings = "NotificationSettings",

	// Catalog dropdown modals
	CatalogPropsEditor = "CatalogPropsEditor",
	Healthcheck = "Healthcheck",

	ActionConfirm = "ActionConfirm",

	ExportPdf = "ExportPdf",

	GesAdmin = "GesAdmin",

	DefaultModal = "DefaultModal",
	UnsavedChangesModal = "UnsavedChangesModal",

	TauriGesSignIn = "TauriGesSignIn",

	CreateAccessToken = "CreateAccessToken",
	ShowAccessToken = "ShowAccessToken",

	GesCloudUrl = "GesCloudUrl",
	GesCloudSignIn = "GesCloudSignIn",
	GesCloudInviteUser = "GesCloudInviteUser",
	GesCloudInviteMismatch = "GesCloudInviteMismatch",
	GesCloudOrganizationSettings = "GesCloudOrganizationSettings",
	GesCloudSignOut = "GesCloudSignOut",

	AlertConfirm = "AlertConfirm",

	AgentContextUsageModal = "AgentContextUsageModal",
}

export default ModalToOpen;
